import { render, staticRenderFns } from "./verification_page.vue?vue&type=template&id=edd089b0"
import script from "./verification_page.vue?vue&type=script&lang=js"
export * from "./verification_page.vue?vue&type=script&lang=js"
import style0 from "./verification_page.vue?vue&type=style&index=0&id=edd089b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports